import BaseView from "@core/View.js";

export default class PackageView extends BaseView{
    constructor(model){
        super(model);
        this._model._view = this;
        this._parentEl = this._model._parent._view._packageBoxEl;
        this._parentModel = this._model._parent;
    }

    getMainSkuImg(item){
        let html = "";
        if (!this._parentModel._invalid) {
            html = `<div class="fl i_img">
                    <a href="${item._link}" target="_blank">
                        <img tag='mainsku_img' src="${item._img}" alt="">
                    </a>
                </div>`
        } else {
            let msg = this._parentModel.getInvalidMsg();
            html = `<div class="fl i_img">
                <img src="//p2.lefile.cn/fes/cms/2020/10/23/mou9t4e1ut7py4hz2n38plgd2ah0i8070424.png" alt="">
                <div class="already_sold_box">
                <p class="sold_text">${msg}</p>
                </div>
                <div class="find_similar_dialog"></div>
            </div>`;
        }
        return html;
    }
    itemOptionsStyle(){
        return `opacity:${(this._model._parent._invalid ) ? '0.5' : '1'}`
    }
    getItems(){
        let html = "";
        this._model._items.forEach((item) => {
            html += `<div class="clearfix form package">
                <div class="fl i_checkbox">
                    
                </div>
                <div class="fl i_checkboxs">
                </div>
                ${this.getMainSkuImg(item)}
                <div class="fl i_desc">
                    <h3  style="${this.itemOptionsStyle()}"><a href="${item._link}" target="_blank">${item._name}</a></h3>
                </div>
                <div class="fl le_width_172 i_price">&nbsp;</div>
                <div style="${this.itemOptionsStyle()}" class="fl le_width_172 i_quantity">1件/套 x ${item._count}</div>
                <div class="fl le_width_172 i_sum">&nbsp;</div>
                <div class="fl le_width_116 i_action">&nbsp;</div>
            </div>`;
        });
        return html;
    }

    render(){
        let html = this.getItems();
        $(this._parentEl).append($(html));
    }
}